export function textEditorValidation(language){
    let elements =  Array.from(document.querySelectorAll(`.requiredDescription${language}`));
    let classes = Array.from(elements[0].nextSibling.classList);
    if(!classes.includes("d-none")){
        elements[0].nextSibling.classList.add("d-none");
    } 
} 